import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [centers, setCenters] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [centerFilter, setCenterFilter] = useState("all");
  const [dateRange, setDateRange] = useState("month");

  const refreshMeta = async () => {
    try {
      const [c, d] = await Promise.all([api.get("/centers"), api.get("/departments")]);
      setCenters(c.data);
      setDepartments(d.data);
    } catch (e) { /* ignore */ }
  };

  useEffect(() => { refreshMeta(); }, []);

  return (
    <AppContext.Provider value={{ centers, departments, centerFilter, setCenterFilter, dateRange, setDateRange, refreshMeta }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
